import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RiskTemplate } from '../../../../models/risk-template';
import { AgilityRiskService } from '../../../../providers/agility-risk.service';
import { AgilityRiskFormulaHelperService } from '../../../../providers/agility-risk-formula-helper.service';
import { TranslateService } from '@ngx-translate/core';
import { AgilityRiskSpinnerService } from '../../../../providers/agility-risk-spinner.service';
import { DialogService } from 'primeng/dynamicdialog';
import { RiskTemplateTypes } from '../../../../models/risk-template-types';
import { ActivatedRoute, Router } from '@angular/router';
import { AgilityRiskMessageService } from '../../../../providers/agility-risk-message.service';

@Component({
  selector: 'lib-risk-template-header',
  templateUrl: './risk-template-header.component.html',
  styleUrls: ['./risk-template-header.component.scss']
})
export class RiskTemplateHeaderComponent implements OnInit {
  @Input() templateId: string;
  @Output() savedTemplateId: EventEmitter<string> = new EventEmitter<string>();
  public submitted = false;
  templateTypes: { label: string; value: string }[];
  templateTargetTypes: { label: string; value: string }[];
  public template: RiskTemplate;
  public expanded: boolean;

  constructor(private riskService: AgilityRiskService,
              private formulaHelper: AgilityRiskFormulaHelperService,
              private translateService: TranslateService,
              private messageService: AgilityRiskMessageService,
              private spinner: AgilityRiskSpinnerService,
              private router: Router,
              private route: ActivatedRoute,
              // test begin
              private dialogService: DialogService
              // test end
  ) {
  }

  ngOnInit(): void {
    // open the header if a new one. collapse if editing an existing one.
    this.expanded = !this.templateId;

    this.setTargetTypes();
    this.setTemplateTypes();

    if (this.templateId) {
      this.spinner.start();
      this.riskService.getRiskTemplateHeader(this.templateId).subscribe({
        next: res => {
          this.template = res;
          this.spinner.stop();
        },
        error: err => {
          this.messageService.error(this.translateService.instant('common.error'), this.translateService.instant('common.msgFailedToLoadTemplate'));
          this.spinner.stop();
        }
      });
    } else {
      this.template = new RiskTemplate();
      this.template.name = null;
      this.template.description = null;
      this.template.targetEntityType = null;
      this.template.templateType = RiskTemplateTypes.overAllRisk;
    }
  }

  setTargetTypes() {
    const targetTypes = this.formulaHelper.targetTypesForTemplates;
    targetTypes.forEach(tt => tt.label = this.translateService.instant(`targetTypes.${tt.label}`));
    targetTypes.splice(0, 0, {value: null, label: this.translateService.instant('targetTypes.all')});
    this.templateTargetTypes = targetTypes;
  }

  setTemplateTypes() {
    const templateTypes = this.formulaHelper.templateTypesForSelect;
    templateTypes.forEach(tt => tt.label = this.translateService.instant(`riskTemplates.templateTypes.${tt.label}`));
    this.templateTypes = templateTypes;
  }

  onSaveTemplateHeader() {
    this.submitted = true;
    if (!this.isValid()) {
      this.messageService.error(this.translateService.instant('common.error'), this.translateService.instant('common.pleaseFillAllRequiredFields'));
      return;
    }

    this.spinner.start(this.translateService.instant('common.saving'));
    this.riskService.saveRiskTemplateHeader(this.template).subscribe({
      next: res => {
        this.messageService.success(this.translateService.instant('common.success'), this.translateService.instant('riskTemplates.msgSavedTemplate'));
        this.savedTemplateId.emit(res.id);
        this.template = res;
        this.spinner.stop();
      },
      error: err => {
        this.messageService.error(this.translateService.instant('common.error'), this.translateService.instant('riskTemplates.msgFailedToSaveTemplate'));
        this.spinner.stop();
      }
    });
  }

  isValid(): boolean {
    this.submitted = true;
    if (!this.template.name ||
      !this.template.description ||
      !this.template.templateType) {
      return false;
    }
    return true;
  }
}
